import _ from "lodash";
import BaseApiModel from "scripts/models/baseApiModel";
// import NotFoundSyncError from "scripts/exceptions/notFoundSyncError";

import thumbnailFallbackUrl from "images/fallbacks/fallback_380_380.png";
import fallBackImage from "images/fallbacks/fallback_160_160.png";

class ModuleModel extends BaseApiModel {
  urlRoot() {
    return `${this.apiUrlRoot}/modules/`;
  }

  parse(response) {
    // Catch any INACTIVE modules
    // if (response.status === "INACTIVE") {
    //   throw new NotFoundSyncError(["Inactive module"]);
    // }

    // TODO: need proper image for this model
    // Add module icon fallback image
    response.iconFallbackUrl = fallBackImage;
    response.thumbnailFallbackUrl = thumbnailFallbackUrl;

    response.whiteMediaBadges = _.filter(response.mediaBadges, {
      type: "white",
    });
    response.blackMediaBadges = _.filter(response.mediaBadges, {
      type: "black",
    });

    return response;
  }
}

export default ModuleModel;
